import React from "react";

// MUI
import { IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// Utils
import { isValidArr } from "../../utility/utils";

// Models
import { BidCreationDocumentModel } from "../../models/BidCreationDocumentsModel";

interface IFile {
  file: BidCreationDocumentModel;
  onClick: (id: string) => void;
}

interface IFileGrid {
  files: BidCreationDocumentModel[];
  onClick: (id: string) => void;
}

const File = ({ file, onClick }: IFile) => {
  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <Typography variant="subtitle2">
        {file.file.path} - {file.file.size} bytes
      </Typography>
      <IconButton onClick={() => onClick(file.id)}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
};

const FileGrid = ({ files, onClick }: IFileGrid) => {
  const renderFile = (file: BidCreationDocumentModel, index: number) => {
    return <File file={file} onClick={onClick} key={index} />;
  };

  if (!isValidArr(files)) {
    return null;
  }

  return <section className="file-list">{files.map(renderFile)}</section>;
};

export default FileGrid;
